import React from 'react'
import DataField from "../../../utils/DataField"
import {titleCase,upperCase,checkNested} from "../../../utils/utils"
import moment from "moment"

function LegacyCNHOCR(props){
    const { cnh_verification } = props
    const { CNHOCR } = props

    return(
        <div style={{display:"flex", width:"70%", flexDirection: "column"}}>
            <DataField
                    title={"Nome"}
                    label={titleCase(CNHOCR.name, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "name", "flag") ? cnh_verification.name.flag : null}
                    tooltipText={checkNested(cnh_verification, "name", "flag") ? cnh_verification.name.flag === "positive" ? "Nome validado" : 
                        (checkNested(cnh_verification, "name", "description") && checkNested(cnh_verification, "name","similarity")) ? 
                        "Nome encontrado em Bureau: " + titleCase(cnh_verification.name.description) + " (Similaridade de " + (cnh_verification.name.similarity*100).toFixed(0)  + "% )": 
                        checkNested(cnh_verification, "name", "description") ? "Nome encontrado em Bureau: " + titleCase(cnh_verification.name.description) : 
                        checkNested(cnh_verification, "name","similarity") ? "Similaridade de " + (cnh_verification.name.similarity*100).toFixed(0)  + "%" : "Indisponível" :  "Indisponível"}
            />
            <DataField
                    title={"CPF"}
                    label={CNHOCR.cpf_number ? CNHOCR.cpf_number : "-"}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "document_number", "flag") ? cnh_verification.document_number.flag : null}
                    tooltipText={checkNested(cnh_verification, "document_number", "flag") ? cnh_verification.document_number.flag === "positive" ? "CPF validado" : 
                    checkNested(cnh_verification.document_number.description) ? "CPF encontrado em Bureau: " + titleCase(cnh_verification.document_number.description) :
                    "Indisponível"  : "Indisponível"}
            />                    
            <DataField
                    title={"Data de Nascimento"}
                    label={CNHOCR.birthdate ? moment(CNHOCR.birthdate).format('DD/MM/YYYY') : "-"}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "birthdate", "flag") ? cnh_verification.birthdate.flag : null}
                    tooltipText={checkNested(cnh_verification, "birthdate", "flag") ? cnh_verification.birthdate.flag === "positive" ? "Data validada" : 
                    checkNested(cnh_verification.birthdate.description) ? "Data de nascimento encontrada em Bureau: " + moment(cnh_verification.birthdate.description).format('DD/MM/YYYY') :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Nome do Pai"}
                    label={titleCase(CNHOCR.father_name, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "father_name", "flag") ? cnh_verification.father_name.flag : null}
                    tooltipText={checkNested(cnh_verification, "father_name", "flag") ? cnh_verification.father_name.flag === "positive" ? "Nome validado" : 
                        (checkNested(cnh_verification, "father_name", "description") && checkNested(cnh_verification, "father_name","similarity")) ? 
                        "Nome encontrado em Bureau: " + titleCase(cnh_verification.father_name.description) + " (Similaridade de " + (cnh_verification.father_name.similarity*100).toFixed(0)  + "% )": 
                        checkNested(cnh_verification, "father_name", "description") ? "Nome encontrado em Bureau: " + titleCase(cnh_verification.father_name.description) : 
                        checkNested(cnh_verification, "father_name","similarity") ? "Similaridade de " + (cnh_verification.father_name.similarity*100).toFixed(0)  + "%" : "Indisponível" :  "Indisponível"}
            />
            <DataField
                    title={"Nome da Mãe"}
                    label={titleCase(CNHOCR.mother_name, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "mother_name", "flag") ? cnh_verification.mother_name.flag : null}
                    tooltipText={checkNested(cnh_verification, "mother_name", "flag") ? cnh_verification.mother_name.flag === "positive" ? "Nome validado" : 
                        (checkNested(cnh_verification, "mother_name", "description") && checkNested(cnh_verification, "mother_name","similarity")) ? 
                        "Nome encontrado em Bureau: " + titleCase(cnh_verification.mother_name.description) + " (Similaridade de " + (cnh_verification.mother_name.similarity*100).toFixed(0)  + "% )": 
                        checkNested(cnh_verification, "mother_name", "description") ? "Nome encontrado em Bureau: " + titleCase(cnh_verification.mother_name.description) : 
                        checkNested(cnh_verification, "mother_name","similarity") ? "Similaridade de " + (cnh_verification.mother_name.similarity*100).toFixed(0)  + "%" : "Indisponível" :  "Indisponível"}
            />
            <DataField
                    title={"RG"}
                    label={upperCase(CNHOCR.rg_number, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "rg", "number", "flag") ? cnh_verification.rg.number.flag : null}
                    tooltipText={checkNested(cnh_verification, "rg", "number", "flag") ? cnh_verification.rg.number.flag === "positive" ? "Número do RG validado" : 
                    checkNested(cnh_verification.rg.number.description) ? "Número de RG encontrado em Bureau: " + titleCase(cnh_verification.rg.number.description) :
                    "Indisponível" : "Indisponível"}
                    
            />
            <DataField
                    title={"Orgão Emissor do RG"}
                    label={upperCase(CNHOCR.rg_issuer, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "rg", "issuer", "flag") ? cnh_verification.rg.issuer.flag : null}
                    tooltipText={checkNested(cnh_verification, "rg", "issuer", "flag") ? cnh_verification.rg.issuer.flag === "positive" ? "Orgão emissor do RG validado" : 
                    checkNested(cnh_verification.rg.issuer.description) ? "Orgão emissor encontrado em Bureau: " + upperCase(cnh_verification.rg.issuer.description) :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Estado Emissor do RG"}
                    label={upperCase(CNHOCR.rg_issuer_state, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "rg", "issuer_state", "flag") ? cnh_verification.rg.issuer_state.flag : null}
                    tooltipText={checkNested(cnh_verification, "rg", "issuer_state", "flag") ? cnh_verification.rg.issuer_state.flag === "positive" ? "Estado emissor do RG validado" : 
                    checkNested(cnh_verification.rg.issuer_state.description) ? "Estado emissor encontrado em Bureau: " + upperCase(cnh_verification.rg.issuer_state.description) :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"CNH"}
                    label={CNHOCR.cnh_number ? CNHOCR.cnh_number : "-"}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "cnh", "register_number", "flag") ? cnh_verification.cnh.register_number.flag : null}
                    tooltipText={checkNested(cnh_verification, "cnh", "register_number", "flag") ? cnh_verification.cnh.register_number.flag === "positive" ? "Número da CNH validado" : 
                    checkNested(cnh_verification.cnh.register_number.description) ? "Número da CNH encontrado em Bureau: " + titleCase(cnh_verification.cnh.register_number.description) :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Categoria da Habilitação"}
                    label={upperCase(CNHOCR.category, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "cnh", "category", "flag") ? cnh_verification.cnh.category.flag : null}
                    tooltipText={checkNested(cnh_verification, "cnh", "category", "flag") ? cnh_verification.cnh.category.flag === "positive" ? "Habilitação validada" : 
                    checkNested(cnh_verification.cnh.category.description) ? "Habilitação encontrada em Bureau: " + titleCase(cnh_verification.cnh.category.description) :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Data de Emissão"}
                    label={CNHOCR.issuance_date ? moment(CNHOCR.issuance_date).format('DD/MM/YYYY') : "-"}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "cnh", "issuance_date", "flag") ? cnh_verification.cnh.issuance_date.flag : null}
                    tooltipText={checkNested(cnh_verification, "cnh", "issuance_date", "flag") ? cnh_verification.cnh.issuance_date.flag === "positive" ? "Data validada" : 
                    checkNested(cnh_verification.cnh.issuance_date.description) ? "Data de emissão encontrada em Bureau: " + moment(cnh_verification.cnh.issuance_date.description).format('DD/MM/YYYY') :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Data de Vencimento"}
                    label={CNHOCR.expiration_date ? moment(CNHOCR.expiration_date).format('DD/MM/YYYY') : "-"}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "cnh", "expiration_date", "flag") ? cnh_verification.cnh.expiration_date.flag : null}
                    tooltipText={checkNested(cnh_verification, "cnh", "expiration_date", "flag") ? cnh_verification.cnh.expiration_date.flag === "positive" ? "Data validada" : 
                    checkNested(cnh_verification.cnh.expiration_date.description) ? "Data de vencimento encontrada em Bureau: " + moment(cnh_verification.cnh.expiration_date.description).format('DD/MM/YYYY') :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Data da Primeira Habilitação"}
                    label={CNHOCR.first_issuance_date ? moment(CNHOCR.first_issuance_date).format('DD/MM/YYYY') : "-"}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "cnh", "first_issuance_date", "flag") ? cnh_verification.cnh.first_issuance_date.flag : null}
                    tooltipText={checkNested(cnh_verification, "cnh", "first_issuance_date", "flag") ? cnh_verification.cnh.first_issuance_date.flag === "positive" ? "Data validada" : 
                    checkNested(cnh_verification.cnh.first_issuance_date.description) ? "Data de da primeira habilitação encontrada em Bureau: " + moment(cnh_verification.cnh.first_issuance_date.description).format('DD/MM/YYYY') :
                    "Indisponível" : "Indisponível"}
            />
            <DataField
                    title={"Cidade Emissora"}
                    label={(CNHOCR.cnh_issuer_city && CNHOCR.cnh_issuer_state) ? [titleCase(CNHOCR.cnh_issuer_city, "-"), upperCase(CNHOCR.cnh_issuer_state, "-")].join(", ") : titleCase(CNHOCR.cnh_issuer_city, "-")}
                    size={"normalMediumSize"}
                    titleNoWrap={true}
                    margin="5px"
                    check={checkNested(cnh_verification, "cnh", "issuer_city", "flag") ? cnh_verification.cnh.issuer_city.flag : null}
                    tooltipText={checkNested(cnh_verification, "cnh", "issuer_city", "flag") ? cnh_verification.cnh.issuer_city.flag === "positive" ? "Local de emissão da CNH validado" : 
                    checkNested(cnh_verification.cnh.issuer_city.description) ? "Local de emissão encontrado em Bureau: " + titleCase(cnh_verification.cnh.issuer_city.description) :
                    "Indisponível" : "Indisponível"}
                    
            />
        </div>
    )
}

export default LegacyCNHOCR